import Cookies from 'js-cookie'

const TokenKey = 'Auth-Token'
const ExpiresIn = 'Auth-Expires'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.set(ExpiresIn, 0)
  return Cookies.remove(TokenKey)
}

export function getExpires() {
  return Cookies.get(ExpiresIn)
}

export function setExpires() {
  return Cookies.set(ExpiresIn, new Date().getTime())
}



// WEBPACK FOOTER //
// ./src/assets/js/auth.js